import React, { useContext } from "react";
import { func, array, string, objectOf, arrayOf } from "prop-types";
import FilterDropdown from "../FilterDropdown/FilterDropdown.jsx";
import { QueryStringContext } from "../../QueryStringContext/QueryStringContext.jsx";

const propTypes = {
  sorters: array,
};

const Sorters = (props) => {
  const { sorters } = props;
  const { setQueryStringState, model } = useContext(QueryStringContext);
  const { dictionary } = model;

  if (!sorters) {
    return null;
  }

  //if there is only one sorter and is relevance, return null, otherwise return sorters
  if (sorters && sorters.length === 1 && sorters[0].value === "relevance")
    return null;

  const filterDropdownValues = sorters.map((sorter) => {
    return {
      raw_value: sorter.identifier,
      values: {
        value: sorter.label,
        active: sorter.selected || false,
      },
    };
  });

  return (
    <div className="sorters">
      <div className="sorters__list">
        <FilterDropdown
          label={dictionary.sortBy}
          param="f"
          id="sorter"
          values={filterDropdownValues}
          type="sort"
          onFacetChange={(facetGroup, facetValue, selected) => {
            setQueryStringState({
              sort_by: selected.raw_value,
              sort_order: selected.direction,
            });
          }}
          selectedFacets={objectOf(arrayOf(string))}
        />
      </div>
    </div>
  );
};

Sorters.propTypes = propTypes;
export default Sorters;
